import { useState } from "react";
import { useChild } from "../lib/childContext";
import { ChevronDown, Check } from "lucide-react";

export default function ChildSwitcher() {
  const { list, selected, selectChild } = useChild();
  const [open, setOpen] = useState(false);

  if (!selected || list.length < 2) return null;

  return (
    <div className="relative inline-block" data-testid="child-switcher">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="child-switcher-toggle"
        className="inline-flex items-center gap-2.5 rounded-full bg-white border border-[#2C2B29]/10 pl-2 pr-4 py-1.5 transition-colors duration-300 hover:bg-[#F2EFEA]"
      >
        <span
          className="h-7 w-7 rounded-full bg-cover bg-center"
          style={{
            backgroundImage: selected.portrait_url
              ? `url(${selected.portrait_url})`
              : undefined,
            backgroundColor: "#E6BFA6",
          }}
        />
        <span className="text-sm font-medium text-[#2C2B29]">{selected.name}</span>
        <ChevronDown size={14} strokeWidth={1.5} className="text-[#6A6863]" />
      </button>

      {open && (
        <>
          <div
            className="fixed inset-0 z-30"
            onClick={() => setOpen(false)}
            aria-hidden
          />
          <div
            className="absolute z-40 left-0 mt-2 min-w-[220px] rounded-2xl bg-white border border-[#2C2B29]/10 shadow-[0_8px_30px_rgb(44,43,41,0.08)] overflow-hidden"
            data-testid="child-switcher-menu"
          >
            {list.map((c) => (
              <button
                key={c.id}
                type="button"
                data-testid={`child-switcher-item-${c.id}`}
                onClick={() => {
                  selectChild(c.id);
                  setOpen(false);
                }}
                className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-[#FBF9F6] transition-colors duration-300"
              >
                <span
                  className="h-7 w-7 rounded-full bg-cover bg-center"
                  style={{
                    backgroundImage: c.portrait_url
                      ? `url(${c.portrait_url})`
                      : undefined,
                    backgroundColor: "#E6BFA6",
                  }}
                />
                <span className="flex-1 text-sm text-[#2C2B29]">{c.name}</span>
                {c.id === selected.id && (
                  <Check size={14} strokeWidth={1.5} className="text-[#9BA995]" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
